import { Boxes, ExternalLink, LayoutDashboard, LogOut, PackagePlus, PanelTop, ShoppingBag, Store, CreditCard } from 'lucide-react'
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

const items = [
  ['/admin', 'Visão geral', LayoutDashboard],
  ['/admin/produtos', 'Produtos', Boxes],
  ['/admin/produtos/novo', 'Novo produto', PackagePlus],
  ['/admin/conteudo', 'Vitrine', PanelTop],
  ['/admin/pedidos', 'Pedidos', ShoppingBag],
  ['/admin/pagamentos', 'Pagamentos', CreditCard]
] as const

export function AdminShell() {
  const navigate = useNavigate()
  const logout = async () => { await supabase.auth.signOut(); navigate('/admin/login', { replace: true }) }

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-brand"><strong>GK MAISON</strong><span>PAINEL DA LOJA</span></div>
        <nav aria-label="Navegação administrativa">
          {items.map(([to, label, Icon]) => <NavLink key={to} to={to} end={to === '/admin'}><Icon size={18} />{label}</NavLink>)}
        </nav>
        <div className="admin-sidebar__footer">
          <Link className="admin-store-link" to="/" target="_blank" rel="noreferrer"><Store size={18} />Ver loja<ExternalLink size={14} /></Link>
          <button onClick={logout}><LogOut size={18} />Sair</button>
        </div>
      </aside>
      <main className="admin-main"><Outlet /></main>
    </div>
  )
}
